import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { BlogEntity } from 'src/app/interfaces/blog/blog-entity';

@Component({
  selector: 'hepatits',
  templateUrl: './hepatits.component.html',
  styleUrls: ['./hepatits.component.css']
})
export class HepatitsComponent implements OnInit {
  private routeSub: Subscription;

  constructor(private route: ActivatedRoute,
    public http:HttpClient
    ) { 
      this.blog=<BlogEntity>{};
    }

  ngOnInit(): void {
    this.routeSub = this.route.params.subscribe(params => {
      console.log(params) //log the entire params object
      this.blogId=params['id'] //log the value of id
    });
    if(this.blogId){
      this.getBlog()
    }
    // let text = JSON.stringify(this.string);
    // console.log(text);
  }
  public getBlog(){
      this.http.get('assets/blog.json').subscribe(r=>{
        this.blogList=r as BlogEntity[];
       const index= this.blogList.findIndex(r=>r.code==this.blogId);
        if(index>=0){
            this.blog=this.blogList[index];
        }
      })
  }

  @Input() public blog!:BlogEntity;
  public blogList:BlogEntity[];
  public blogId:number;




}
